module.exports = __webpack_public_path__ + "assets/img/img-10.99762f38.png";